import { getLinkDetails } from "@/utils/utilities";

const DesktopNav = ({ leftNavigation }) => {
  return (
    <nav className="desktop-nav-wrapper d-none d-lg-block mr-auto " aria-label="Main">
      <ul className="desktop-nav d-flex align-items-center mb-0 list-unstyled">
        {Array.isArray(leftNavigation) &&
          leftNavigation?.map((link) => {
            const { linkTitle, linkUrl, dataLinkInfo, linkTarget, linkID, onClick } = getLinkDetails(link);
            if (!linkTitle || !linkUrl) return null;
            return (
              <li className="desktop-nav-item mx-3" key={link?.uid}>
                <a
                  href={linkUrl}
                  target={linkTarget}
                  className="desktop-nav-link font-weight-bold text-uppercase text-decoration-none text-nowrap trackContent"
                  id={linkID}
                  data-link-info={dataLinkInfo}
                >
                  {linkTitle}
                </a>
              </li>
            );
          })}
      </ul>
    </nav>
  );
};

export default DesktopNav;